import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorGlobalIssueListEmbedRoute: InvariantJiraRoute = {
	name: 'global-issue-list-embed',
	path: '/jira/issues/embed',
	exact: true,
	query: ['jql?'],
};
